import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { featureFlagGuard } from '../../_core/guards/feature-flag.guard';
import { FeatureFlagKeys } from '../../_core/models/FeatureFlags';
import { GrantComponent } from './grant/grant.component';

const routes: Routes = [
  {
    path: '',
    component: GrantComponent,
  },
  {
    path: 'add-charity',
    loadChildren: () => import('../charity/charity.module').then((m) => m.CharityModule),
  },
  {
    path: 'manage-recurring',
    loadComponent: () =>
      import('../distribution/manage-recurring/manage-recurring.component').then(
        (m) => m.ManageRecurringComponent
      ),
    canMatch: [featureFlagGuard],
    data: { featureFlagKey: FeatureFlagKeys.RecurringGrants },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GrantRoutingModule {}
